import { Col, Row, Space, Table, Tag, Typography, Modal } from "antd";
import Banner from "../Banner";
import {
  useGetIncomingMLSRequst,
  useGetOutcomingMLSRequst,
} from "../MLSPortFolio/ServerSideStates";
import { useEffect, useState } from "react";
import { FormOutlined, PictureOutlined } from "@ant-design/icons";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import dayjs from "dayjs";
import PriceFormatter from "apps/Common/PriceFormatter";
import SubmittedUser from "./Components/SubmittedUser";
import { MazakaDrawer } from "apps/Common/MazakaDrawer";
import PageTitle from "apps/Common/PageTitle";
import { MazakaButton } from "apps/Common/MazakaButton";
import {
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import {
  acceptMLSRequest,
  rejectMLSRequest,
} from "../../../MLS/Components/MLSPortFolio/Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";

const ManageRequestIndex = (props: any) => {
  const { Text } = Typography;
  const [isShowSubmittedUsersModal, setIsShowSubmitteduusersModal] =
    useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const filter = {
    PageSize: -1,
    IncludeProperties: [
      "Advert.User",
      "Advert.Store",
      "Advert.Currency",
      "Advert.Country",
      "Advert.City",
      "Advert.District",
      "Advert.Neighbourhood",
      "Advert.AdvertMedia",
      "Advert.AdvertMedia.Media",
      "Advert.AdvertContactType",
      "Advert.AdvertContactType.ContactType",
      "Advert.AdvertOptionAttr",
      "Advert.AdvertFaultyPieceAttr",
    ],
  };

  const incomingRequests = useGetIncomingMLSRequst(filter);
  const outgoingRequests = useGetOutcomingMLSRequst(filter);
  type RequestDataType = {
    id: number;
    invitationStatus?: number;
    [key: string]: any;
  };

  const [requestData, setRequestData] = useState<RequestDataType[]>([]);

  useEffect(() => {
    if (props.type === "send") {
      setRequestData(outgoingRequests?.data?.data?.data || []);
    } else {
      setRequestData(incomingRequests?.data?.data?.data || []);
    }
  }, [props.type, incomingRequests?.data, outgoingRequests?.data]);


  const handleConfirm = (record: any, type: number) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu istek ${type === 1 ? "kabul edilir" : "reddedilir"}. Onaylıyor musunuz?`,
      okText: "Onayla",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          type === 1
            ? await acceptMLSRequest(record.ppsRequestItem[0].id)
            : await rejectMLSRequest(record.ppsRequestItem[0].id);

          openNotificationWithIcon("default", "İşlem Başarılı ✅");

          // Lokal listeyi güncelle (requestData state'ini)
          const newData = [...requestData];
          const index = newData.findIndex((item) => item.id === record.id);
          if (index !== -1) {
            newData[index].invitationStatus = type;
            setRequestData(newData);
          }

          // Query invalidation (Cache temizliği)
          incomingRequests.refetch();
          outgoingRequests.refetch();
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };




  const columns = [
    {
      title: <PictureOutlined />,
      dataIndex: "advert",
      width: "20%",
      key: "image",
      render: (advert: any) => (
        <div className="!flex  items-center gap-2">
          <LazyLoadImage
            wrapperWidth="100px"
            wrapperHeight="100px"
            imageClassName="!rounded-md !object-contain"
            src={
              advert?.advertMedia?.length > 0
                ? setBackEndUlr() + "/" + advert.advertMedia[0]?.media?.fullPath
                : ""
            }
            alt=""
          />
          <div>
            <div>
              <Text>{<PriceFormatter inputPrice={advert?.price} />}</Text>
            </div>
            <div>
              <Text>{advert?.title}</Text>
            </div>
          </div>
        </div>
      ),
    },

    {
      title: "Tarih",
      dataIndex: "insertDate",
      key: "date",
      render: (date: any) => {
        return (
          <>
            <Text className="mobile-label" data-label="Tarih">
              {dayjs(date).format("DD.MM.YYYY")}
            </Text>
          </>
        );
      },
    },
    {
      title: "Geçerlilik Tarihi",

      render: (_: string, record: any) => {
        console.log("record", record);
        return (
          <>
            {record?.pps?.expiryDate && (
              <Text className="mobile-label" data-label="Geçerlilik Tarihi">
                {dayjs(record?.pps?.expiryDate).format("DD.MM.YYYY")}
              </Text>
            )}
          </>
        );
      },
    },
    ...(props.type !== "send" ? [
    {
      title: "Komisyon",

      render: (_: string, record: any) => {
        console.log("record", record);
        return (
          <>
            {record?.pps?.commissionRate && (
              <Text className="mobile-label" data-label="Geçerlilik Tarihi">
                % {record?.pps?.commissionRate}
              </Text>
            )}
          </>
        );
      },
    },
    {
      title: "Açıklama",

      render: (_: string, record: any) => {
        console.log("record", record);
        return (
          <>
            {record?.pps?.description && (
              <Text className="mobile-label" data-label="Geçerlilik Tarihi">
                {record?.pps?.description}
              </Text>
            )}
          </>
        );
      },
    },
    {
      title: "İşlemler",
      render: (_: any, record: any) => (

        <div className="!flex gap-2">
          <MazakaButton
            className="!bg-green-500"
            onClick={() => handleConfirm(record, 1)}
            icon={<CheckOutlined className="" />}
          >
            Kabul Et
          </MazakaButton>
          <MazakaButton
            className="!bg-red-500"
            onClick={() => handleConfirm(record, 2)}
            icon={<CloseOutlined />}
          >
            Reddet
          </MazakaButton>
        </div>
      ),
    },
    ] : []),
    
    ...(props.type === "send"
      ? [
        {
          title: "Bekleyen İstek Sayısı",
          dataIndex: "waitingRequestCount",
          key: "title",
          render: (value: any) => {
            return (
              <>
                <Col xs={24}>
                  <Text
                    className="mobile-label"
                    data-label="Bekleyen İstek Sayısı"
                  ></Text>
                  <Tag color="#800080">{value || 0}</Tag>
                </Col>
              </>
            );
          },
        },
        {
          title: "Onaylanmış İstek Sayısı",
          dataIndex: "approvedRequestCount",
          key: "approvedRequestCount",
          render: (value: any) => (
            <Col xs={24}>
              <Text
                className="mobile-label"
                data-label="Onaylanmış İstek Sayısı"
              ></Text>
              <Tag color="#30cdc0">{value || 0}</Tag>
            </Col>
          ),
        },
        {
          title: "Reddedilen İstek Sayısı",
          dataIndex: "rejectedRequestCount",
          key: "rejectedRequestCount",
          render: (value: any) => (
            <Col xs={24}>
              <Text
                className="mobile-label"
                data-label="Reddedilen İstek Sayısı"
              ></Text>
              <Tag color="error">{value || 0}</Tag>
            </Col>
          ),
        },
      ]
      : []),

      

    // {
    //   title: "",

    //   render: (user: any, record: any) => (
    //     <div
    //       className="!flex justify-center items-center gap-2 cursor-pointer"
    //       onClick={async () => {
    //         await setSelectedRecord(record);
    //         setIsShowSubmitteduusersModal(true);
    //       }}
    //     >
    //       <Text className="!text-xs !text-indigo-500 ">
    //         Detayları Görmek İçin Tıklayınız
    //       </Text>
    //       <FormOutlined className="!text-indigo-500" />
    //     </div>
    //   ),
    // },
  ];

  return (
    <>
      <Col xs={24} className="table-container">
        <Row gutter={[0, 20]}>
          <Col xs={24}>
            <Banner />
          </Col>
          <Col span={24} className="!flex justify-center">
            <PageTitle
              title={
                props.type === "send" ? "Giden Talepler" : "Gelen Talepler"
              }
              count={requestData.length}
            />
          </Col>
          <Col xs={24}>
            <Table
              loading={
                props.type === "send"
                  ? outgoingRequests.isLoading || outgoingRequests.isFetching
                  : incomingRequests.isLoading || incomingRequests.isFetching
              }
              dataSource={requestData}
              columns={columns}
              rowClassName="responsive-row"
              rowKey="id"
              pagination={false}
            />
          </Col>
        </Row>
      </Col>

      <MazakaDrawer
        open={isShowSubmittedUsersModal}
        toggleVisible={() => {
          setIsShowSubmitteduusersModal(!isShowSubmittedUsersModal);
        }}
        footer={false}
        title={false}
        width={"80%"}
      >
        <SubmittedUser
          data={selectedRecord}
          setData={setSelectedRecord}
          type={props.type}
        />
      </MazakaDrawer>
    </>
  );
};

export default ManageRequestIndex;
